
export default {
  name: 'TwoColumnsSlice',
  props: ['slice'],
  methods: {
    isPNG(image){
      return image?.url.includes('.png')
    }
  }
}
